import Zone from "@frog/source/models/Zone.js"

export function areAllUnaffiliatedUnitsDefeated(stage, {affiliation, encounterKey, doNotIncludeUnitKey} = {}) {
    encounterKey = encounterKey || stage.currentEncounterKey
    affiliation = affiliation || stage.player.affiliation
    const remainingUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation != affiliation
            && unit.affiliation != "nothing"
            && unit.affiliation != "none"
            && unit.affiliation != "nothing of concern"
            && unit.state != "pacified"
            && unit.key != doNotIncludeUnitKey
            && (unit.isDead != true && unit.isRemoved != true)
            && (encounterKey == undefined || Zone.isInBounds(stage.encounters[encounterKey], unit.position))
    })
    return remainingUnits.length == 0
}

export function areAllAffiliatedUnitsDefeated(stage, {affiliation, encounterKey, doNotIncludeUnitKey} = {}) {
    encounterKey = encounterKey || stage.currentEncounterKey
    affiliation = affiliation || stage.player.affiliation
    const aliveUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == affiliation
            && unit.key != doNotIncludeUnitKey
            && unit.isDead != true
            && (encounterKey == undefined || Zone.isInBounds(stage.encounters[encounterKey], unit.position))
    })
    return aliveUnits.length == 0
}

export function areAllAffiliatedUnitsDead(stage, {affiliation, encounterKey}) {
    encounterKey = encounterKey || stage.currentEncounterKey
    const remainingUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == affiliation
            && unit.isDead != true
            && Zone.isInBounds(stage.encounters[encounterKey], unit.position)
    })
    return remainingUnits.length == 0
}

export function hasEscaped(stage, {affiliation, encounterKey}) {
    encounterKey = encounterKey || stage.currentEncounterKey
    const alliedUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == affiliation
            && unit.isDead != true
            // && Zone.isInBounds(stage.encounters[encounterKey], unit.position)
    })
    if(alliedUnits.length == 0) return false
    const escapedUnits = alliedUnits.filter((unit) => unit.isRemoved == true)
    return alliedUnits.length == escapedUnits.length
}

export function hasReachedSpot(stage, {spotTag, affiliation}) {
    const spots = Object.values(stage.world.spots).filter((spot) => spot.tag == spotTag)
    const alliedUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == (stage.player.affiliation || affiliation)
            && unit.isDead != true
    })
    const winningUnit = alliedUnits.find((unit) => {
        return spots.find((spot) => {
            return spot.position.x == unit.position.x
                && spot.position.y == unit.position.y
        })
    })
    return winningUnit != undefined
}

export function hasReachedZone(stage, {role, affiliation}) {
    const spots = Object.values(stage.units).filter((unit) => unit.type == "zone" && unit.role == role && unit.isDead != true)
    const alliedUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == (stage.player.affiliation || affiliation)
            && unit.isDead != true
    })
    const winningUnit = alliedUnits.find((unit) => {
        return spots.find((spot) => {
            return spot.position.x == unit.position.x
                && spot.position.y == unit.position.y
        })
    })
    return winningUnit != undefined
}
